<template>
  <b-row class="px-4">
    <b-col sm="12" class="result-summary-flex rounded">
     <div class="d-sm-flex justify-content-between">
       <div v-if="params.departureName">
          <span class="tag-details"><translate>Departure</translate>:</span> <span class="name-details">{{ params.departureName }}</span>
        </div>
        <div>
          <span class="tag-details"><translate>Transport</translate>: </span>
          <span v-if="params.transport === 'flight'" class="name-details" v-translate>Flight</span>
          <span v-if="params.transport === 'bus'" class="name-details" v-transport>Bus</span>
          <span v-if="params.transport === 'own'" class="name-details" v-transport>Own</span>
        </div>
        <div>
          <span class="tag-details"><translate>Destination</translate>: </span> <span class="name-details">{{params.resortName}}</span>
        </div>
        <div>
          <span class="tag-details"><translate>Date</translate>: </span> <span class="name-details">{{departureDate}}</span>
        </div>
        <div>
          <span class="tag-details"><translate>Nights</translate>: </span> <span class="name-details">{{params.duration}}</span>
        </div>
        <div v-for="(room, index) in params.rooms" :key="index">
          <span class="tag-details"><translate>Room</translate> {{index + 1 }} - </span>
          <span>{{room.adults}} </span><span class="name-details"> adults</span>
          <span v-if="room.ages && room.ages.length" class="name-details">, {{ room.ages.length }} children</span>
        </div>
     </div>
     <hr class="my-1"/>
     <div>
       <small class="float-right">
          <b v-translate>generated by</b> -
          <span class="name-details"> {{userData.fname}} {{userData.lname}}</span>
       </small>
     </div>
    </b-col>
  </b-row>
</template>

<script>
import moment from 'moment'
import auth from 'b2b-common/mixins/auth'

export default {
  props: ['params'],
  mixins: [auth],
  computed: {
    departureDate: function () {
      const d = moment(this.params.date, 'X')
      return d.format('DD-MM-YYYY')
    }
  }
}
</script>
